import { render, staticRenderFns } from "./topup_gca.vue?vue&type=template&id=2a6105bf&"
import script from "./topup_gca.vue?vue&type=script&lang=js&"
export * from "./topup_gca.vue?vue&type=script&lang=js&"
import style0 from "./topup_gca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports